/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VIDEO_CONTENT_CATEGORIES',
  PUT: 'UPDATE_VIDEO_CONTENT_CATEGORIES',
  DELETE: 'DELETE_VIDEO_CONTENT_CATEGORIES',
  RESET: 'RESET_VIDEO_CONTENT_CATEGORIES',
  RELOAD: 'RELOAD_VIDEO_CONTENT_CATEGORIES',
};

export const getDraftId = () => (`videoContentCategory-draft${new Date().valueOf()}`);

export const videoContentCategoriesReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      let newValue = action.payload;
      if (state.length == 0) {
        newValue = { ...newValue, defaultCategory: true };
      }

      return [
        ...state,
        { ...newValue, id },
      ];
    case types.PUT:
      return action.payload;
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
